// Table
import Table from '@/components/ui/table/Table'

// UI
import ProfileAvatar from '../ui/ProfileAvatar'
import ProfileLastActivity from '@/components/profiles/ProfileLastActivity'

// Mantine
import { Anchor, Button } from '@mantine/core'

// Dayjs
import dayjs from '@/lib/dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import Calendar from 'dayjs/plugin/calendar'

import 'dayjs/locale/fr'
dayjs.extend(LocalizedFormat)
dayjs.extend(Calendar)

dayjs.locale('fr')

// Cells
const CodeCell = (item) => (
    <div className="table-cell p-5">
        <div className="flex gap-6 items-center">
            <ProfileAvatar profile={item} size="md" className="mr-3" />

            <div className="flex flex-col items-start">
                <Anchor href={`/profiles/${item.id}`}>{item.name}</Anchor>

                <span className="text-sm text-gray-400">{item.email?.endsWith('@accounts.baltic-watches.invalid') ? 'Sans email personnel' : item.email}</span>
            </div>
        </div>
    </div>
)

const StatusCell = (item) => (
    <div className="table-cell p-5 text-sm text-gray-500 align-middle">
        {item.disabled && <span className="text-red-500">Accès désactivé</span>}

        {!item.disabled && item.role === 'ADMIN' && (
            <span className="text-gray-500">Baltic Watches</span>
        )}

        {!item.disabled && item.role === 'MNP' && (
            <span className="text-gray-500">MNP</span>
        )}

        {!item.disabled && item.role === 'RETAILER' && !item.retailer && (
            <Button variant="default" size="xs">
                Affecter le revendeur
            </Button>
        )}

        {!item.disabled && item.role === 'RETAILER' && item.retailer && (
            <Anchor size="sm" href={`/retailers/${item.retailer.id}`}>
                {item.retailer.name}
            </Anchor>
        )}
    </div>
)

const WarrantiesCell = (item) => (
    <div className="table-cell p-5 text-sm text-gray-500 align-middle">
        <Anchor href={`/warranties?user_id=${item.id}`} size="sm">
            {Intl.NumberFormat('fr-FR').format(item.warranties_count)}{' '}
            {item.warranties_count > 1 ? 'garanties' : 'garantie'}
        </Anchor>
    </div>
)

export default function ProfileTable() {
    const availableColumns = [
        {
            name: 'Nom',
            key: 'name',
            display: 'mandatory',
            sortable: true,
            component: CodeCell,
        },

        {
            name: 'Role',
            key: 'role',
            display: 'optional_default',
            component: StatusCell,
            width: 300,
        },

        {
            name: 'Dernière activité',
            key: 'last_seen_at',
            display: 'optional_default',
            sortable: true,
            component: (item) => (
                <div className="table-cell p-5 text-sm text-gray-500 align-middle">
                    <ProfileLastActivity lastSeenAt={item.last_seen_at} disabled={item.disabled} />
                </div>
            ),
            width: 200,
        },

        {
            name: 'Garanties',
            key: 'warranties_count',
            display: 'optional_default',
            sortable: false,
            component: WarrantiesCell,
            width: 200,
        },
    ]

    // Filters
    const roleOptions = [
        { value: 'ADMIN', label: 'Baltic' },
        { value: 'MNP', label: 'MNP' },
        { value: 'RETAILER', label: 'Revendeur' },
    ]

    const availableFilters = [
        {
            name: 'Rôle',
            key: 'role',
            type: 'multiselect',
            options: roleOptions,
        },
        {
            name: 'Activation',
            key: 'disabled',
            type: 'multiselect',
            options: [
                { value: 'true', label: 'Désactivé' },
                { value: 'false', label: 'Activé' },
            ],
        },
    ]

    return (
        <Table
            engineApiEndpoint="/profiles"
            availableColumns={availableColumns}
            availableFilters={availableFilters}
            searchable={true}
            defaultSortColumn="name"
            defaultSortDirection="asc"
        />
    )
}
